import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import {
  IconComponent,
  InputComponent,
  FormFieldComponent,
  IconButtonComponent,
  DropdownHeaderComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-redactor-inserts-dropdown-header',
  templateUrl: 'redactor-inserts-dropdown-header.component.html',
  styleUrls: ['./redactor-inserts-dropdown-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownHeaderComponent,
    IconButtonComponent,
    FormFieldComponent,
    InputComponent,
    IconComponent,
  ],
})
export class RedactorInsertsDropdownHeaderComponent {
  @Input() public label: string;
  @Input() public hasBackAction: boolean = true;
  @Input() public searchQuery: string;
  @Input() public hasSearch: boolean = false;
  @Input() public hasSettings: boolean = false;
  @Input() public searchPlaceholder: string;

  public goBack = output<MouseEvent>();
  public goToSettings = output<MouseEvent>();
  public searchQueryChange = output<string>();
  public closeDropdown = output<void>();
  public focusChanges = output<boolean>();

  public onFocusChanges(value: boolean): void {
    this.focusChanges.emit(value);
  }
}
